import { css } from "@emotion/react";
import { ReactNode } from "react";

import { PC_BENTO_ITEM_GAP_SIZE } from "~/components/me/bento/containers/BentoItemRow";
import { fixedHeight, fixedWidth } from "~/lib/client/design";
import useIsSpMode from "~/lib/client/hooks/useIsSpMode";

type Props = {
  children: ReactNode;
  size: {
    width: number;
    height: number;
  };
  empty?: boolean;
  isSp?: boolean;
};

const PC_BENTO_WIDTH = 230;
const PC_BENTO_HEIGHT = 230;
const SP_BENTO_WIDTH = 180;
const SP_BENTO_HEIGHT = 180;

const BentoItemContainer = ({ children, size, empty }: Props) => {
  const isSpMode = useIsSpMode();

  return (
    <div css={rootStyle({ ...size, empty: !!empty, isSp: !!isSpMode })}>
      {children}
    </div>
  );
};

const rootStyle = ({
  width,
  height,
  empty,
  isSp,
}: {
  width: number;
  height: number;
  empty: boolean;
  isSp: boolean;
}) => {
  const widthPadding = isSp ? 0 : (width - 1) * PC_BENTO_ITEM_GAP_SIZE;

  return css`
    ${fixedWidth(
      `${width * (isSp ? SP_BENTO_WIDTH : PC_BENTO_WIDTH) + widthPadding}px`
    )};
    ${fixedHeight(`${height * (isSp ? SP_BENTO_HEIGHT : PC_BENTO_HEIGHT)}px`)};
    padding: 0.25rem;
    border-radius: ${isSp ? "1rem" : "1.25rem"};
    border: ${empty ? "none" : "1px solid #fff;"};
    background: ${empty ? "none" : "rgba(238, 238, 238, 0.85)"};
    backdrop-filter: blur(20px);

    display: flex;
  `;
};

export { PC_BENTO_WIDTH, PC_BENTO_HEIGHT, SP_BENTO_WIDTH, SP_BENTO_HEIGHT };
export default BentoItemContainer;
